export const UNPLACED_SECTION_ID = 'unplaced'
const splitChar = '/'
export const buildId = (sectionId: string, itemId: string): string => {
  return `${sectionId}${splitChar}${itemId}`
}

export const getItemId = (id: string) => {
  const parts = id.split(splitChar)
  return parts.length >= 1 ? parts[1] : id
}

export const getSectionId = (id: string) => {
  const parts = id.split(splitChar)
  return parts.length >= 1 ? parts[0] : null
}
